import { ACTIVITY_KEY } from './reducers';

/**
 * Get the index of the current activity in progress (or undefined if there is
 * not one)
 * @param state
 */
export const getCurrentActivityIndex = state =>
    state.getIn([ACTIVITY_KEY, 'currentActivity', 'activityIndex']);
